import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicComponent } from './public.component';
import { ClinicsComponent } from './clinics/clinics.component';
import { TypesComponent } from './types/types.component';
import { DentistsComponent } from './dentists/dentists.component';
import { AvailableHoursComponent } from './available-hours/available-hours.component';
import { SummaryComponent } from './summary/summary.component';
import { PublicGuard } from './shared/guards/public.guard';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ScheduleTypeGuard } from './shared/guards/schedule-type.guard';
import { DentistGuard } from './shared/guards/dentist.guard';
import { AvailableHoursGuard } from './shared/guards/available-hours.guard';
import { SummaryGuard } from './shared/guards/summary.guard';
import { ConfirmationGuard } from './shared/guards/confirmation.guard';
import { PublicRoutesEnum } from './shared/interfaces/public-routes.enum';
import { ErrorPageComponent } from '../../shared/components/error-page/error-page.component';
import { PageNotFoundComponent } from '../../shared/components/page-not-found/page-not-found.component';
import { SummaryTermsComponent } from './summary-terms/summary-terms.component';

let newRoute : any = []
if(sessionStorage.getItem("app") == "app"){
newRoute = [
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'term',
    component: SummaryTermsComponent,
  },
  {
    path: ':api',
    children: [
      {
        path: ':clientKey',
        component: PublicComponent,
        canActivate: [PublicGuard],
        children: [
          {
            path: PublicRoutesEnum.CLINICS,
            component: ClinicsComponent,
          },
          {
            path: PublicRoutesEnum.TYPES,
            component: TypesComponent,
            canActivate: [ScheduleTypeGuard],
          },
          {
            path: PublicRoutesEnum.DENTISTS,
            component: DentistsComponent,
            canActivate: [DentistGuard],
          },
          {
            path: PublicRoutesEnum.AVAILABLE_HOURS,
            component: AvailableHoursComponent,
            canActivate: [AvailableHoursGuard],
          },
          {
            path: PublicRoutesEnum.SUMMARY,
            component: SummaryComponent,
            canActivate: [SummaryGuard],
          },
          {
            path: PublicRoutesEnum.CONFIRMATION,
            component: ConfirmationComponent,
            canActivate: [ConfirmationGuard],
          },
          { path: '', redirectTo: 'clinics' },
          { path: '**', redirectTo: '/404' },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '404' },
];
} else {
  newRoute = [
    { 
      path: '404', 
      component: PageNotFoundComponent
    },
    { 
      path: 'error', 
      component: ErrorPageComponent
    },
    { 
      path: 'term', 
      component: SummaryTermsComponent
    },
    { 
      path: ':clientKey', 
      component: PublicComponent,
      canActivate: [ PublicGuard ],
      children: [
        {
          path: PublicRoutesEnum.CLINICS, 
          component: ClinicsComponent,
        },
        {
          path: PublicRoutesEnum.TYPES, 
          component: TypesComponent,
          canActivate: [ ScheduleTypeGuard ]
        },
        {
          path: PublicRoutesEnum.DENTISTS, 
          component: DentistsComponent,
          canActivate: [ DentistGuard ]
        },
        {
          path: PublicRoutesEnum.AVAILABLE_HOURS, 
          component: AvailableHoursComponent,
          canActivate: [ AvailableHoursGuard ]
        },
        {
          path: PublicRoutesEnum.SUMMARY, 
          component: SummaryComponent,
          canActivate: [ SummaryGuard ]
        },
        {
          path: PublicRoutesEnum.CONFIRMATION, 
          component: ConfirmationComponent,
          canActivate: [ ConfirmationGuard ]
        },
        { path: '', redirectTo: 'clinics' },
        { path: '**', redirectTo: '/404' }
      ]
    },
    { path: '**', redirectTo: '404' }
  ];
}
const routes: Routes = newRoute
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
